import Swal from "sweetalert2";
import SweetAlertPopup from "../common/sweetAlertPopup";
import { baseUrlServer } from "./nodeApiList";
import axios from "axios";
import CryptoJS from 'crypto-js';
import { getCryptoConfig, isCryptoReady, waitForCrypto } from "../../cryptoConfig";

const BASEURL = process.env.REACT_APP_BASENAME;

const validateResponse = (apiData) => {
  if (typeof apiData == "undefined") {
    return {
      status: false,
      error: "unauthorized",
    };
  }
  return apiData;
};

const API = axios.create({
  baseURL: baseUrlServer,
});

API.interceptors.request.use((config, response) => {
  const token = sessionStorage.getItem("updatedToken");
  // console.log("responseHeader", response)
  // const username = sessionStorage.getItem("username");
  // const bankcode = sessionStorage.getItem("bankcode");
  // if (token) config.headers.authorization = ${token};
  // if (token) config.headers['Authorization'] = token;
  if (token) config.headers["Authorization"] = "Bearer " + token;
  // console.log('token',token)
  // if (username) {
  //   config.headers["X-Username"] = JSON.parse(username);
  // }
  // if (bankcode) {
  //   config.headers["X-Bankcode"] = JSON.parse(bankcode);
  // }
  return config;
});

// API.interceptors.response.use((response) => {
//   // Log response headers
//   console.log("ResponseHHHH:", response.headers);

//   return response;
// }, (error) => {
//   // Handle the error response
//   if (error.response && error.response.status === 403) {
//     Swal.fire({
//       title: "Oops...Session has expired!!!",
//       icon: "question",
//       confirmButtonText: "Login Again",
//       allowOutsideClick: false
//     }).then((result) => {
//       if (result.isConfirmed) {
//         sessionStorage.clear();
//         localStorage.clear();
//         window.location.href = `/${BASEURL}/auth/login`;
//         window.location.reload();
//       }
//     });
//   }

//   return Promise.reject(error);
// });

function encryptAES(payload) {
  const { AES_KEY, AES_IV } = getCryptoConfig();

  console.log("AES_KEY", AES_KEY)
  console.log("AES_IV", AES_IV)
  // ✅ Convert to WordArray
  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV);

  // console.log("AES_KEY", AES_KEY);
  // console.log("AES_IV", AES_IV);
  // console.log("Payload", JSON.stringify(payload));

  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    key,
    {
      iv: iv,                      // ✅ correct key name
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return encrypted.toString();     // Base64 string
}


function decryptAES(encData) {



  const { AES_KEY, AES_IV, SECRET_KEY, SALT } = getCryptoConfig();

  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV);
  // console.log("AES_KEY", AES_KEY)
  // console.log("AES_IV", AES_IV)
  const decrypted = CryptoJS.AES.decrypt(
    encData,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}


export async function postApiData(url, payload, headers = {}) {


  await waitForCrypto();
  const { SECRET_KEY, SALT } = getCryptoConfig();


  const isApiEncrypted = process.env.REACT_APP_IS_API_ENCRYPTED;

  let finalPayload = payload;
 
  if (isApiEncrypted === "Y") {
    const encryptedData = encryptAES(payload);
    finalPayload = { encData: encryptedData };
  }


  // 2️⃣ Calculate hash on payload
  // console.log("JSON.stringify(payload) + SECRET_KEY + SALT", JSON.stringify(payload) + SECRET_KEY + SALT)
  const hashedData = CryptoJS.SHA256(JSON.stringify(payload) + SECRET_KEY + SALT)
    .toString(CryptoJS.enc.Hex);

  
  try {
    const response = await API.post(url, finalPayload, {
      timeout: 900000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Hash": hashedData,
        ...headers
      }
    });

 
    // ✅ Only decrypt when encryption is ON
    if (isApiEncrypted === "Y" && response?.data?.encData) {
      const decrypted = decryptAES(response.data.encData);
      response.data = JSON.parse(decrypted);
    }
    // if (response?.data?.encData) {
    //   const decrypted = decryptAES(response.data.encData);
    //   response.data = JSON.parse(decrypted);
    // }

  
    if (response.headers.authorization) {
      sessionStorage.setItem("updatedToken", response.headers?.authorization);
    }

    const x = JSON.stringify(response.data) + SECRET_KEY + SALT;

    const hashedDataResponse = CryptoJS.SHA256(x).toString(CryptoJS.enc.Hex);
   

    const receivedHash = response.headers.hash;
   
    if (receivedHash != hashedDataResponse) {
      SweetAlertPopup("Hacker activity detected.. Please logout", "Error", "error")
      return;
    }

    // Log response headers

    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      }).catch((err) => { SweetAlertPopup('kk', 'kkj') });
    }
    return validateResponse(response.data);
  } catch (error) {
    if (error.response && error.response.status == 403) {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      }).catch((err) => { SweetAlertPopup('kk', 'kkj') });
      // window.location.href = "/vakrangeeatmadminportal"
    } else if (error.name == "AxiosError") {
      Swal.fire({
        title: "Network Error",
        icon: "error",
      })

    }
    else {
      console.error("Error in postApiData:", error);
      throw error; // Rethrow the error for higher level handling if necessary
    }
  }
}

export async function getApiData(url, headers) {
  try {
    //const response = await API.get(url,headers);
    const response = await API.get(url, { headers });
    if (response.headers.authorization) {
      sessionStorage.setItem("updatedToken", response.headers?.authorization);
    }

    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      }).catch((err) => { SweetAlertPopup('kk', 'kkj') });
    }
    return validateResponse(response.data);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      // Redirect to login page

      // const navigate = useNavigate();
      //       navigate("/auth/login")


      // window.location.href = "/vakrangeeatmadminportal"
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      });
      // window.location.href = "/vakrangeeatmadminportal"

    } else {
      // Handle other errors
      console.error("Error in axiosGetApiData:", error);
      throw error; // Rethrow the error for higher level handling if necessary
    }
  }
}

export async function getApiDataPdf(url, headers) {
  try {
    //const response = await API.get(url,headers);
    const response = await API.get(url, { headers });
    if (response.headers.authorization) {
      sessionStorage.setItem("updatedToken", response.headers?.authorization);
    }

    if (response.data.respCode === "IS") {
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      }).catch((err) => { SweetAlertPopup('kk', 'kkj') });
    }
    return validateResponse(response);
  } catch (error) {
    if (error.response && error.response.status === 403) {
      // Redirect to login page

      // const navigate = useNavigate();
      //       navigate("/auth/login")


      // window.location.href = "/vakrangeeatmadminportal"
      await Swal.fire({
        title: "Oops...Session has been expired!!!",
        icon: "question",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "Login Again",
        denyButtonText: `Deny`,
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = `/${BASEURL}/auth/login`
          window.location.reload();
        } else if (result.isDenied) {

        }
      });
      // window.location.href = "/vakrangeeatmadminportal"

    } else {
      // Handle other errors
      // console.error("Error in axiosGetApiData:", error);
      // throw error; // Rethrow the error for higher level handling if necessary
      if (error.name == "AxiosError") {
        SweetAlertPopup("System is under maintenance. Please try after some time.", "", "error")

      }
      else {
        console.error("Error in postApiData:", error);
        throw error; // Rethrow the error for higher level handling if necessary
      }
    }
  }
}


export async function postApiDataNew(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),

    },
  });
  if (response.headers.authorization) {
    sessionStorage.setItem("updatedToken", response.headers?.authorization);
  }
  const apiData = await response.json();
  return validateResponse(apiData);
}


export async function postfileData(url, file, headers) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(url, {

    // mode: 'no-cors',
    method: "POST",
    body: formData,
    // body: JSON.stringify(payload),
    // redirect: 'follow',
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept": "/",
      "type": "formData",
      ...headers
    },
  });
  const apiData = await response.json();
  return validateResponse(apiData);
}


export async function updateApiData(url, payload) {

  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  });

  const apiData = await response.json();
  return validateResponse(apiData);
}